import PropTypes, {InferProps} from "prop-types";
import {ProfileAvatarEditorView} from "./profile-avatar-editor.view";
import {currentPerson, useAvatarModal, usePerson, useViewV2} from "@betrue/front/services";
import {useCallback} from "react";

const ProfileAvatarEditorPropsTypes = {
  avatarLabel: PropTypes.string,
  dialogTitle: PropTypes.string,
  dialogSave: PropTypes.string,
  dialogCancel: PropTypes.string,
  dialogReset: PropTypes.string,
  dropZoneLabel: PropTypes.string,
  dialogSubtitle: PropTypes.string,
}

export type ProfileAvatarEditorProps = InferProps<typeof ProfileAvatarEditorPropsTypes>

export const ProfileAvatarEditor = (props: ProfileAvatarEditorProps) => {

  const [person, {updateAvatar, getPersonById}] = usePerson()
  const [isOpen, setOpen] = useAvatarModal()

  const [viewPerson, setSubject,subjectId, subjectModel, setSubjectId, setSubjectModel] = useViewV2(currentPerson, person, getPersonById)

  const handleSubmit = useCallback((image) => {
    updateAvatar(viewPerson.id, image)
    handleClose()
  }, [viewPerson, isOpen])

  const handleClose = () => {
    setOpen(!isOpen)
  }

  if (!viewPerson) {
    return <></>
  }

  return <>
    <ProfileAvatarEditorView onClose={handleClose}
                             onSubmit={handleSubmit}
                             modalOpen={isOpen}
                             currentImage={null}/>
  </>
}

ProfileAvatarEditor.propTypes = ProfileAvatarEditorPropsTypes
